import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import br.com.heyagenda.ui.screens.LandingScreen
import br.com.heyagenda.ui.screens.PublicBookingScreen
import br.com.heyagenda.web.WebRoute
import br.com.heyagenda.web.WebRouter
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.DocumentReadyState
import org.w3c.dom.LOADING

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val run = {
        try {
            val isDev = br.com.heyagenda.web.WebFirebaseConfig.isDevEnvironment()
            val firebaseOptions = br.com.heyagenda.web.WebFirebaseConfig.getFirebaseOptions()
            Firebase.initialize(
                context = null,
                options = firebaseOptions
            )
            println(">>> [HeyAgenda Web] Firebase initialized successfully. Env: ${if (isDev) "DEV (dev.heyagenda.com.br)" else "PROD (heyagenda.com.br)"} | Project: ${firebaseOptions.projectId}")
        } catch (e: Throwable) {
            println(">>> [HeyAgenda Web] Firebase init error: ${e.message}")
        }

        val root = document.getElementById("root") ?: document.body
        if (root != null) {
            val routeState = mutableStateOf(WebRouter.getCurrentRoute())

            window.onpopstate = {
                routeState.value = WebRouter.getCurrentRoute()
            }

            ComposeViewport(root) {
                br.com.heyagenda.ui.theme.HeyAgendaTheme {
                    when (val route = routeState.value) {
                        is WebRoute.Home -> {
                            LandingScreen(
                                onOpenBooking = { slug ->
                                    val target = WebRoute.Booking(slug)
                                    WebRouter.navigateTo(target)
                                    routeState.value = target
                                }
                            ).Content()
                        }
                        is WebRoute.Booking -> {
                            val savedName = try {
                                kotlinx.browser.localStorage.getItem("heyagenda_client_name")
                            } catch (_: Throwable) { null }
                            val savedPhone = try {
                                kotlinx.browser.localStorage.getItem("heyagenda_client_phone")
                            } catch (_: Throwable) { null }

                            PublicBookingScreen(
                                slugOrUid = route.slug,
                                initialClientName = savedName,
                                initialClientPhone = savedPhone,
                                onBookingSuccess = { name, phone ->
                                    try {
                                        if (name.isNotBlank()) kotlinx.browser.localStorage.setItem("heyagenda_client_name", name)
                                        if (phone.isNotBlank()) kotlinx.browser.localStorage.setItem("heyagenda_client_phone", phone)
                                    } catch (_: Throwable) {}
                                },
                                onHomeClick = {
                                    val target = WebRoute.Home
                                    WebRouter.navigateTo(target)
                                    routeState.value = target
                                }
                            ).Content()
                        }
                    }
                }
            }
        } else {
            println(">>> [HeyAgenda Web ERROR] Neither #root nor document.body was found.")
        }
    }

    if (document.readyState != DocumentReadyState.LOADING) {
        run()
    } else {
        document.addEventListener("DOMContentLoaded", { run() })
    }
}
